(ns ui.editors.card.shared.table-editor
  (:require
   [common.localization :as loc]
   [oops.core :as oops]
   [common.util :as cu]
   [ui.editors.card.shared.sortable-field-list :as sortable-field-list]))

(defn table-settings
  [{:keys [sort-by-field sort-direction sort-by-field-options
           set-sort-by-field set-sort-direction
           group-by-field set-group-by-field
           group-by-field-options]}]
  (let []
    [:div
     {:class "grid grid-cols-[auto,1fr] *:py-3 *:pr-5"}
     [:div (loc/tr :sort-by-text)]
     [:div
      [:select
       {:value (if sort-by-field
                 (cu/kw->str sort-by-field)
                 "-")
        :on-change (fn [e]
                     (let [value-str (-> e
                                         (oops/oget "target")
                                         (oops/oget "value"))
                           value (if (= value-str "-")
                                   nil
                                   (keyword value-str))]
                       (set-sort-by-field value)))
        :class "min-w-24"}
       [:option {:value "-"} "-"]
       (->> sort-by-field-options
            (map
             (fn [{:keys [value label]}]
               ^{:key (str value)}
               [:option
                {:value (cu/kw->str value)}
                label])))]]
     (when sort-by-field
       [:<>
        [:div (loc/tr :sort-direction)]
        [:div
         [:select
          {:value (subs (str sort-direction) 1)
           :on-change (fn [e]
                        (let [value (-> e
                                        (oops/oget "target")
                                        (oops/oget "value")
                                        keyword)]
                          (set-sort-direction value)))}
          [:option
           {:value :asc}
           (loc/tr :ascending)]
          [:option
           {:value :desc}
           (loc/tr :descending)]]]])

     [:div (loc/tr :group-by-text)]
     [:div
      [:select
       {:value (if group-by-field
                 (cu/kw->str group-by-field)
                 "-")
        :on-change (fn [e]
                     (let [value-str (-> e
                                         (oops/oget "target")
                                         (oops/oget "value"))
                           value (if (= value-str "-")
                                   nil
                                   (keyword value-str))]
                       (set-group-by-field value)))}
       [:option {:value "-"} "No grouping"]
       (->> group-by-field-options
            (map (fn [{:keys [value label]}]
                   ^{:key (str value)}
                   [:option
                    {:value (cu/kw->str value)}
                    label])))]]]))

(defn view
  [{:keys [selected-columns available-column-options
           add-column remove-column reorder-columns
           set-sort-direction] :as props}]
  [:div
   {:class "flex flex-col gap-3"}
   [:div
    {:class "flex justify-between items-center gap-3"}
    [:div
     {:class "flex flex-col gap-2"}
     [:h5 
       {:class "text-semibold"}
      (loc/tr :card-editor/table-settings)]
     [:p
      {:class "text-sm m-0 text-base-light-text-paler"}
      (loc/tr :card-editor/reorder-columns-by-dragging)]]]
   [:div
    [:p 
     {:class "text-semibold"}
     (loc/tr :columns)]
    [sortable-field-list/view
     {:selected-options selected-columns
      :available-options available-column-options
      :reorder-items reorder-columns
      :add-field add-column
      :remove-field remove-column}]]
   [table-settings props]])
